import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';

import {LoadingPage} from '../../../../../shared/components/loading/loading.page.component';
import {LicenseService} from '../../../../services/license.service';
import {NotificationService} from '../../../../services/notification.service';
import {FullscreenService} from '../../../../services/fullscreen.service';
import {EvaluationService} from '../../evaluation.service';
import {EvaluationScormApiService} from './scorm.api.service';

declare var $: any;
declare var API_1484_11: any;
declare var API: any;


const IMG_BUCKET_URL: string = 'http://itpx-cdn.s3.amazonaws.com/solar/scorm-player/';

@Component({
    selector: 'itpx-evaluation-scorm',
    templateUrl: './scorm.component.html',
    styleUrls: ['./scorm.component.css']
})
export class EvaluationScormComponent extends LoadingPage implements OnInit, OnDestroy {

    private player: any;
    private scormLogoutTriggered = new BehaviorSubject<boolean>(false);
    private deliverableId: any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private licenseService: LicenseService,
        private scormApiService: EvaluationScormApiService,
        private notificationService: NotificationService,
        private fullscreenService: FullscreenService,
        private service: EvaluationService
    ) {
        super();
        this.player = window;
    }

    ngOnInit() {

        this.initScormButtons();

        // Hide useless(?) scorm buttons because they break style
        $(document).arrive('#navigationContainer', function () {
            $('#navigationContainer').remove();
        });

        $('#drawerExample2').hide();

        // Show or hide table of contents depending on number of items
        $(document).arrive('#treeContainer', () => {
            let anchors = $('#treeContainer a');

            if (anchors.length <= 1) {
                $('#drawerExample2').remove();
            } else {
                $('#drawerExample2').show();
                let self = this;
                $('#treeContainer a').click(function () {
                    self.loading();
                    $(this).prop('href', window.location.href);
                    $('.drawer').drawer('hide');
                    setTimeout(() => {
                        self.ready();
                    }, 5000);
                    return true;
                });
            }
        });

        // Navigate to dummy page which will redirect back
        // We do this to trigger scorm content refresh to fit resolution
        this.fullscreenService.onFullscreen()
            .skip(1)
            .subscribe(_ => this.router.navigate(['evaluation/dummy']));

        let routeData = this.route.params
          .take(1)
          .map(params => ({ assignmentId: params['assignmentId'], deliverableId: params['deliverableId'] }))
          .cacheResult();

        routeData
          .subscribe(data => this.deliverableId = data.deliverableId);

        // Initially start the scorm player
        routeData
          .flatMap(data => this.licenseService.getEvaluationScormManifest(data.deliverableId).map(body => body.data))
          .flatMap(data => this.startScormPlayer(data))
          .bindToLifecycle(this)
          .subscribe(
            _ => {
              this.ready();
            },
            err => this.handleError(err)
          );
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    private startScormPlayer(manifest: string): Observable<boolean> {
        return Observable.defer(() => {
          this.scormApiService.setTrackingData(this.deliverableId, {organizations: {}, suspend_data: null});

            document.getElementById('placeholder_contentIFrame').innerHTML = '';
            this.player.Run.ManifestByURL(manifest, true);

            return Observable.of(true).delay(5000);
        })
    }

    private handleError(error: any) {
        this.notificationService.error(error, 'Failed');
        this.ready();
    }

    private initScormButtons() {
        let PlayerConfiguration = this.player.PlayerConfiguration;

        PlayerConfiguration.Debug = false;
        PlayerConfiguration.StorageSupport = true;
        PlayerConfiguration.TreeMinusIcon = IMG_BUCKET_URL + 'minus.gif';
        PlayerConfiguration.TreePlusIcon = IMG_BUCKET_URL + 'plus.gif';
        PlayerConfiguration.TreeLeafIcon = IMG_BUCKET_URL + 'leaf.gif';
        PlayerConfiguration.TreeActiveIcon = IMG_BUCKET_URL + 'select.gif';

        PlayerConfiguration.BtnPreviousLabel = 'Previous';
        PlayerConfiguration.BtnContinueLabel = 'Continue';
        PlayerConfiguration.BtnExitLabel = 'Exit';
        PlayerConfiguration.BtnExitAllLabel = 'Exit All';
        PlayerConfiguration.BtnAbandonLabel = 'Abandon';
        PlayerConfiguration.BtnAbandonAllLabel = 'Abandon All';
        PlayerConfiguration.BtnSuspendAllLabel = 'Suspend All';
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/content/scorm/scorm.component.ts